import { Module } from "@/models/modules/Module";
import { DashboardModule } from "@/modules/DashboardModule";
import { ManagementModule } from "@/modules/ManagementModule";

export const modules: Module[] = [DashboardModule, ManagementModule];
